import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const ReferralLinkGenerator = ({ referralCode }) => {
  const [copied, setCopied] = useState(false);
  const referralLink = `${window.location?.origin}/landing-page?ref=${referralCode}`;

  const handleCopyLink = () => {
    navigator.clipboard?.writeText(referralLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 3000);
  };

  const handleShareFacebook = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(referralLink)}`, '_blank');
  };

  const handleShareEmail = () => {
    const subject = 'Únete a Residencial 3 Volcanes';
    const body = `Te invito a conocer Residencial 3 Volcanes. Usa mi enlace de referido: ${referralLink}`;
    window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  return (
    <div className="card p-6 md:p-7 lg:p-8">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center">
          <Icon name="Link" size={24} color="var(--color-primary)" />
        </div>
        <div>
          <h3 className="text-xl font-semibold text-foreground">
            Tu Enlace de Referido
          </h3>
          <p className="text-sm text-muted-foreground">
            Comparte y gana comisiones
          </p>
        </div>
      </div>

      {/* Referral Link Input */}
      <div className="mb-6">
        <div className="flex flex-col md:flex-row gap-3">
          <div className="flex-1">
            <Input
              type="text"
              value={referralLink}
              readOnly
              className="font-data text-sm"
            />
          </div>
          <Button
            variant={copied ? "success" : "default"}
            iconName={copied ? "Check" : "Copy"}
            iconPosition="left"
            onClick={handleCopyLink}
            className="md:w-auto"
          >
            {copied ? 'Copiado' : 'Copiar'}
          </Button>
        </div>
      </div>

      {/* Share Options */}
      <div>
        <p className="text-sm font-medium text-foreground mb-3">
          Compartir en:
        </p>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
          <Button
            variant="outline"
            iconName="Facebook"
            iconPosition="left"
            onClick={handleShareFacebook}
            fullWidth
          >
            Facebook
          </Button>
          <Button
            variant="outline"
            iconName="Mail"
            iconPosition="left"
            onClick={handleShareEmail}
            fullWidth
          >
            Email
          </Button>
          <Button
            variant="outline"
            iconName="Share2"
            iconPosition="left"
            onClick={() => {
              if (navigator.share) {
                navigator.share({
                  title: 'Residencial 3 Volcanes',
                  text: 'Únete a mi red de referidos',
                  url: referralLink
                });
              }
            }}
            fullWidth
          >
            Más
          </Button>
        </div>
      </div>

      {/* Tracking Stats */}
      <div className="mt-6 pt-6 border-t border-border">
        <div className="grid grid-cols-3 gap-4">
          <div className="text-center">
            <p className="text-2xl font-bold text-foreground">247</p>
            <p className="text-xs text-muted-foreground">Clics</p>
          </div>
          <div className="text-center">
            <p className="text-2xl font-bold text-foreground">89</p>
            <p className="text-xs text-muted-foreground">Registros</p>
          </div>
          <div className="text-center">
            <p className="text-2xl font-bold text-success">36%</p>
            <p className="text-xs text-muted-foreground">Conversión</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferralLinkGenerator;